import { SetStateAction, useState } from "react";
import { stdObject } from "../../../data/types/stdObject";
import { toPrice } from "../../../utils/toPrice";
import convertDate from "../../../utils/convertDate";
import { useTranslation } from "react-i18next";
import { colors } from "../../../data/colors";
import WriteInput from "../WriteInput";

export default function DocRecordsBox({ data }: stdObject) {
  const { t } = useTranslation();
  const [docs, setDocs] = useState(data.records.docRecords);
  const [docType, setDocType] = useState("");

  return (
    <div style={{ display: "flex", flexDirection: "column", height: 285 }}>
      <div>
        {
          <WriteInput
            data={{
              label: data.NOMSDD,
              code: data.CODSDD,
              type: "select",
              value: docType,
              onChange: (v: { target: { value: SetStateAction<string> } }) => {
                setDocType(v.target.value);
                setDocs(
                  v.target.value === ""
                    ? data.records.docRecords
                    : data.records.docRecords.filter(
                        (e: stdObject) => e.MKEY === v.target.value,
                      ),
                );
              },
              options: [
                { label: t("p.all"), value: "" },
                ...data.records.docs.map((e: string) => {
                  return {
                    label: t(`c.${e === "PRE" ? "PREP" : e}`),
                    value: e,
                  };
                }),
              ],
              inputStyle: { justifyItems: "center" },
            }}
          />
        }
      </div>
      <div style={{ flex: 1, overflow: "auto" }}>
        <table width="100%" border={0} cellPadding={3} cellSpacing={0}>
          <thead>
            <tr
              className="header noSelect"
              style={{
                backgroundColor: colors.lightGrey,
                textAlign: "center",
              }}
            >
              <th style={{ backgroundColor: colors.blue }}>
                {t(`p.document`)}
              </th>
              <th style={{ backgroundColor: colors.blue }}>{t("p.line")}</th>
              <th style={{ backgroundColor: colors.blue }}>{t("p.date")}</th>
              <th style={{ backgroundColor: colors.blue }}>
                {t("p.quantity")}
              </th>
              <th style={{ backgroundColor: colors.blue }}></th>
              <th style={{ backgroundColor: colors.blue }}>{t("p.price")}</th>
              <th style={{ backgroundColor: colors.blue }}>{t("p.total")}</th>
            </tr>
          </thead>
          <tbody>
            {docs.map((e: stdObject, index: number) => (
              <tr
                key={index}
                style={{
                  position: "sticky",
                  backgroundColor:
                    index % 2 === 0 ? colors.white : colors.lightGrey,
                }}
              >
                <td>
                  {t(`c.${e.MKEY}`)}{" "}
                  <span style={{ whiteSpace: "nowrap" }}>
                    {e.SER}-{e.COD}
                  </span>
                </td>
                <td style={{ textAlign: "center" }}>{e.LIN ? e.LIN : ""}</td>
                <td>{convertDate({ info: e.FEC, time: true, t })}</td>
                <td style={{ textAlign: "center" }}>{e.CAN}</td>
                <td style={{ textAlign: "center" }}>X</td>
                <td style={{ textAlign: "right" }}>{toPrice(e.PRE)}</td>
                <td style={{ textAlign: "right" }}>{toPrice(e.TOT)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
